document.addEventListener('turbolinks:load', function() {
    var folderNumberInput = document.getElementById('folder_number');
  
    if (folderNumberInput) {
      folderNumberInput.addEventListener('input', function() {
        this.value = this.value.replace(/\D/g, '').slice(0, 6);
      });
    }
  });
  